import * as React from 'react';
import { useZustand } from 'use-zustand';
import { shallow } from 'zustand/shallow';
import { pathwayStore } from '../store';
import PathwayStep from './ContentFormats/PathwayStep';
import { Config, isCompleted, isQuiz, progressMap } from '../helper';
import StepIndex, { StepIcon } from './StepIndex';
import Quiz from './ContentFormats/Quiz';
import Summary from './ContentFormats/Summary';
import Video from './ContentFormats/Video';
import classnames from 'classnames';

function getDetailsComponent(step, index, current) {
  const {format} = step;
  switch (format.toLowerCase()) {
    case Config.Step.Format.summary:
      return <Summary step={step} index={index} currentStep={current}/>
    case Config.Step.Format.quiz:
      return <Quiz step={step}/>;
    case Config.Step.Format.video:
      return <Video step={step}/>
    default:
      return <PathwayStep key={step.id} step={step} index={index} currentStep={current}/>
  }
}

function StepWrapper(props) {
  const {step, index} = props;
  const {
    id,
    title,
    format,
    contentType,
    icon = null,
  } = step;

  let stepIcon = null;
  if (isQuiz(format)) {
    stepIcon = Config.Step.Format.quiz;
  }
  if (icon) {
    stepIcon = icon;
  }

  const {
    currentStep,
    passedStepIDs,
    userProgress,
  } = useZustand(
    pathwayStore,
    (state) => ({
      currentStep: state.currentStep,
      passedStepIDs: state.passedStepIDs,
      userProgress: state.userProgress,
    }),
    shallow
  );
  const current = currentStep();
  const passed = isCompleted(step.id, passedStepIDs())
  const summaryEl = React.useRef(null);

  const css = {
    root: classnames({
      'pathway-step': true,
      [`pathway-step--${step.format.toLowerCase()}`]: true,
    })
  }

  const onClickDetails = (evt) => {
    // TODO: Delete?
  }

  const map = progressMap(userProgress);
  const stepProgress = map.get(id);
  return (
    <details className={css.root} id={`step-${id}`} data-status={stepProgress?.status} data-step={id}
             onClick={onClickDetails}>
      <summary ref={summaryEl}>
        <StepIndex index={index + 1} passed={passed}/>
        <StepIcon icon={stepIcon} passed={passed}/>
        <div className='pathway-step__arrow'></div>
        <h2 className='pathway-step__title h--small'>{title}</h2>
        <div className='card-badges mb-0'>
          <div className={`badge badge--format badge--${format.toLowerCase()}`}>{format}</div>
          <div className={`badge badge--content-type badge--${contentType.toLowerCase()}`}>{contentType}</div>
        </div>
      </summary>
      {getDetailsComponent(step, index, current)}
    </details>
  )
}

export default function Content(props) {
  const {
    steps = [],
  } = useZustand(
    pathwayStore,
    (state) => ({
      steps: state.steps,
    }),
    shallow
  );

  if (steps.length === 0) {
    return null;
  }

  return (
    <div className='nv-pathway-content'>
      <div className='nv-pathway-steps'>
        <div>
          {steps.map((step, index) => {
            return (
              <StepWrapper key={step.id} index={index} step={step}></StepWrapper>
            );
          })}
        </div>
      </div>
    </div>
  );
}
